import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CONSENT_KEY = 'turcoaz_cookie_consent';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 sm:p-6"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 rounded-xl shadow-lg p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 text-sm text-slate-600 leading-relaxed">
          We use essential cookies to make our site work. We'd also like to use analytics cookies to improve your experience.{' '}
          <Link
            to="/cookie-policy"
            className="text-teal-600 hover:text-teal-700 font-medium underline-offset-2 hover:underline"
            data-testid="cookie-policy-link"
          >
            Learn more
          </Link>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 border border-slate-200 rounded-md hover:bg-slate-50 transition-colors"
            data-testid="cookie-decline-button"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 text-sm font-medium text-white bg-slate-900 rounded-md hover:bg-slate-800 transition-colors"
            data-testid="cookie-accept-button"
          >
            Accept All
          </button>
        </div>
        <button
          onClick={decline}
          className="absolute top-3 right-3 sm:static p-1 text-slate-400 hover:text-slate-600"
          aria-label="Close cookie banner"
          data-testid="cookie-close-button"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
